<template>
	<div>
		<div class="text-center" v-if="cargando">
			<div class="spinner-border text-dark" role="status">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>
		<div class="card" v-else>
			<img :src="`${UrlImgDrive}${config.logotipo}`" :alt="`Logo ${empresa.nombre}`" style="height:500px;">
			<div class="card-body">
				<h5 class="card-title">{{ empresa.nombre }}</h5>
				<p class="card-text">{{ config.bazar_texto }}</p>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12">
				<form @submit.prevent="buscar">
					<div class="input-group mb-3">
						<input 
							type="search" 
							class="form-control" 
							placeholder="Nombre de la categoria" 
							aria-describedby="btn-buscar"
							v-model="termino"
						>
						<div class="input-group-append">
							<button class="btn btn-outline-secondary" type="submit" id="btn-buscar">Buscar</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="text-center mb-3" v-if="buscando">
			<div class="spinner-border text-dark" role="status">
				<span class="sr-only">Cargando...</span>
			</div>
		</div>
		<div class="row mt-2 mb-5" v-else>
			<template v-for="r in filtrada">
				<div class="col-sm-6 col-lg-4" v-if="r.padre.bazar == 1" :key="r.padre.id">
					<div class="card h-100">
						<div class="row no-gutters h-100">
							<div class="col-md-4 h-100">
								<img :src="`${UrlImgDrive}${r.padre.logo}`" class="card-img h-100" :alt="`Logo ${r.padre.descripcion}`">
							</div>
							<div class="col-md-8">
								<div class="card-body">
									<h5 class="card-title">{{ r.padre.descripcion }}</h5>
									<p class="card-text">{{ r.padre.texto }}</p>
									<a 
										:href="r.padre.externo == 1 ? r.padre.enlace : '#'" 
										class="btn btn-primary btn-sm"
										:target="r.padre.externo == 1 ? '_blank' : ''" 
									>{{ r.padre.externo == 1 ? 'Visitar' : 'Ver' }}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'ManteBazar',
		data: () => ({
			config: {},
			empresa: {},
			lista: [],
			termino: '',
			cargando: true,
			buscando: true
		}),
		created() {
			this.getConfig();
			this.buscar();
		},
		methods: {
			getConfig () {
				this.cargando = true
				axios
				.get(this.UrlBase+'/catalogo/get_configuracion')
				.then(res => {
					if (res.data.config) {
						this.config = res.data.config;
						this.empresa = res.data.empresa;
					} else {
						this.config = {};
						this.empresa = {};
					}
					this.cargando = false
				}).catch(e => {
					alert('Configuración '+e);
					this.cargando = false
				});
			},
			buscar () {
				this.buscando = true
				axios
				.get(this.UrlBase+'/catalogo/get_categoria')
				.then(res => {
					this.lista = res.data.lista;
					this.buscando = false
				}).catch(e => {
					alert("Cat "+e);
					this.buscando = false
				});
			},
		},
		computed: {
			filtrada () {
				return this.lista.filter(o => {
					return o.padre.bazar == 1 && o.padre.descripcion.includes(this.termino)
				});
			}
		}
	}
</script>